const PlatformTypes = Object.freeze({
  ios: 'ios',
  android: 'android'
})

export { PlatformTypes }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/kochava/KochavaPlatformEnum.js